import React from 'react';
import SEO from '../components/SEO';
import { COMPANY, isFilled } from '../data/company';
import './LegalPage.css';

const AboutPage = () => (
  <div className="legal-page">
    <SEO
      title="Hakkımızda"
      description="isBulsun.com, yapay zeka destekli iş arama ve kariyer yönetim platformudur."
      path="/hakkimizda"
    />
    <div className="legal-page__container">
      <h1>Hakkımızda</h1>

      <p>
        <strong>{COMPANY.brand}</strong>, {COMPANY.legalName} tarafından geliştirilen,
        yapay zeka destekli bir iş arama ve kariyer yönetim platformudur. Amacımız, iş
        arayanların doğru pozisyonlara daha hızlı ulaşmasını sağlamak ve başvuru sürecinin
        zahmetli kısımlarını yapay zekaya devretmektir.
      </p>

      <h2>Ne Yapıyoruz?</h2>
      <p>
        Klasik iş arama süreci; onlarca ilanı tek tek incelemeyi, her pozisyon için CV'yi
        yeniden düzenlemeyi ve başvuruları takip etmeyi gerektirir. {COMPANY.brand} bu
        adımları otomatikleştirir:
      </p>
      <ul>
        <li><strong>Akıllı CV oluşturma:</strong> Sohbet ederek veya mevcut CV'nizi yükleyerek dakikalar içinde profesyonel bir özgeçmiş hazırlarsınız.</li>
        <li><strong>İlan uyum analizi:</strong> Bir ilan bağlantısını yapıştırın, CV'nizin o pozisyona ne kadar uyduğunu, ATS uyumluluğunu ve eksik yönlerinizi görün.</li>
        <li><strong>Otomatik başvuru:</strong> Profilinizle yüksek eşleşen ilanlara sizin adınıza başvuru yapılır; tüm başvurular panelinizden takip edilir.</li>
        <li><strong>Mülakat pratiği:</strong> Yapay zeka ile başvurduğunuz pozisyona özel mülakat simülasyonu yaparsınız.</li>
        <li><strong>Yurt dışı rehberliği:</strong> ABD ve Kanada'da çalışmak isteyen adaylar için vize uygunluğu ve kültürel uyum değerlendirmesi sunulur.</li>
      </ul>

      <h2>Yaklaşımımız</h2>
      <p>
        Yapay zekayı bir aracı olarak değil, adayın yanında çalışan bir asistan olarak
        konumlandırıyoruz. Verileriniz size aittir; CV'niz, başvuru geçmişiniz ve kariyer
        profiliniz yalnızca size hizmet sunmak için işlenir. Ayrıntılar{' '}
        <a href="/gizlilik">Gizlilik Politikası</a> sayfamızda açıklanmıştır.
      </p>

      <h2>Kurumsal Bilgiler</h2>
      <ul>
        <li><strong>Ticari Ünvan:</strong> {COMPANY.legalName}</li>
        <li><strong>Marka:</strong> {COMPANY.brand}</li>
        <li><strong>Adres:</strong> {COMPANY.address}</li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
        <li><strong>E-posta:</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li><strong>Vergi Dairesi / No:</strong> {COMPANY.taxOffice} / {COMPANY.taxNumber}</li>
        {isFilled(COMPANY.mersis) && <li><strong>MERSİS No:</strong> {COMPANY.mersis}</li>}
        {isFilled(COMPANY.kep) && <li><strong>KEP Adresi:</strong> {COMPANY.kep}</li>}
      </ul>

      <h2>İletişim</h2>
      <p>
        Soru, öneri ve talepleriniz için{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> adresinden veya{' '}
        {COMPANY.phone} numaralı telefondan bize ulaşabilirsiniz.
      </p>
    </div>
  </div>
);

export default AboutPage;
